export default __webpack_public_path__ + "static/media/home-cafe-img-08.0e619c75.png";